import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'large';
}

export default function ComicCard({ comic, size = 'small' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
      data-product-shop
    >
      <div className={`relative overflow-hidden ${size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'}`}>
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        {comic.rating >= 9.5 && (
          <div className="absolute top-2 right-2">
            <span className="px-1.5 py-0.5 rounded-full text-xs font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
              高分
            </span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
            <span className="text-xs text-foreground-600 font-medium">{comic.rating}</span>
          </div>
          <span className="text-xs text-foreground-400">{comic.views >= 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}</span>
        </div>
      </div>
    </Link>
  );
}